// /* eslint-disable */

// import { Button, Grid } from "@mui/material";
// import React, { useCallback, useContext, useEffect, useState } from "react";
// import { AuthContext, DependentsContext, ThemeContext } from "../../../../../contexts";
// import { VEB_PLAN_NAMES } from "../../../../../constants/plan";
// import EditWholeLifeBeneficiary from "../../../../pages/VEBEnrollment/editBeneficiary/editWholeLifeBeneficiary/EditWholeLifeBeneficiary";
// import EditTermLifeToAge from "../../../../pages/VEBEnrollment/editBeneficiary/editTermLifeToAge/EditTermLifeToAge";
// import { BV2Beneficiery } from "../../../../../types/BV2Beneficiery.types";
// import { trackPromise } from "react-promise-tracker";
// import { api } from "../../../../../utils/api";

// type editBeneficiaryFormPropsType = {
// 	plan_type: string;
// 	plan_code: string;
// 	plan_name: string;
// 	base_plan_name: string | undefined;
// 	enrollments: any;
// 	handleOpenCloseEditBeneficiaryModal: () => void;
// };

// const EditBeneficiaryForm: React.FC<editBeneficiaryFormPropsType> = ({
// 	plan_type,
// 	plan_code,
// 	plan_name,
// 	base_plan_name,
// 	enrollments,
// 	handleOpenCloseEditBeneficiaryModal
// }) => {
// 	const { member } = useContext(AuthContext);
// 	const { dependents } = useContext(DependentsContext);
// 	const { theme } = useContext(ThemeContext);

// 	const [spouse, setSpouse] = useState<any>();

// 	// primary beneficiary
// 	const [employeePrimaryBeneficiary, setEmployeePrimaryBeneficiary] = useState<any[]>([]);
// 	const [childrenPrimaryBeneficiary, setChildrenPrimaryBeneficiary] = useState<any[]>([]);
// 	const [spousePrimaryBeneficiary, setSpousePrimaryBeneficiary] = useState<any[]>([]);

// 	// contingent beneficiary
// 	const [employeeContingentBeneficiary, setEmployeeContingentBeneficiary] = useState<any[]>([]);
// 	const [childrenContingentBeneficiary, setChildrenContingentBeneficiary] = useState<any[]>([]);
// 	const [spouseContingentBeneficiary, setSpouseContingentBeneficiary] = useState<any[]>([]);

// 	// individual enrollments
// 	const [employeeEnrollment, setEmployeeEnrollment] = useState<any>(null);
// 	const [spouseEnrollment, setSpouseEnrollment] = useState<any>(null);
// 	const [childrenEnrollment, setChildrenEnrollment] = useState<any>(null);

// 	// Deriveig  coverage_for from actual enrollment records not from the coverage code
// 	// This ensures if only 1 employee record exists, we only show employee section
// 	const coverage_for = (() => {
// 		const hasSpouse = enrollments.some((e: any) => e["member"]?.relationship === "SPOUSE");
// 		const hasChildren = enrollments.some(
// 			(e: any) => e["member"]?.relationship === "CHILD" || e["member"]?.relationship === "STEP CHILD"
// 		);
// 		if (hasSpouse && hasChildren) return "Employee & Family";
// 		if (hasSpouse) return "Employee & Spouse";
// 		if (hasChildren) return "Employee & Children";
// 		return "Employee Only";
// 	})();

// 	// single source of truth for plan type check
// 	const isCorePlan = plan_type === "core";

// 	const validateBeneficiary = useCallback((beneficiary: BV2Beneficiery[], type: "PRIMARY" | "CONTINGENT") => {
// 		let sum = 0;
// 		for (let i = 0; i < beneficiary.length; i++) {
// 			sum += beneficiary[i].percentage;
// 		}
// 		return sum;
// 	}, []);

// 	const areArraysEqual = (arr1: any[], arr2: any[]) => {
// 		const a1 = arr1 ?? [];
// 		const a2 = arr2 ?? [];
// 		if (a1.length !== a2.length) return false;
// 		const normalize = (obj: any) => JSON.stringify(obj, Object.keys(obj).sort());
// 		const set1 = new Set(a1.map(normalize));
// 		const set2 = new Set(a2.map(normalize));
// 		return [...set1].every((item: any) => set2.has(item));
// 	};

// 	// Shared field-name helpers (defined at component level)
// 	const getPrimary = (enrollment: any): any[] => {
// 		if (enrollment["VEB_primary_beneficiary"]?.length > 0) return enrollment["VEB_primary_beneficiary"];
// 		if (enrollment["primary_beneficiery"]?.length > 0) return enrollment["primary_beneficiery"];
// 		return [];
// 	};

// 	const getContingent = (enrollment: any): any[] => {
// 		if (enrollment["VEB_contingent_beneficiary"]?.length > 0) return enrollment["VEB_contingent_beneficiary"];
// 		if (enrollment["contingent_beneficiery"]?.length > 0) return enrollment["contingent_beneficiery"];
// 		return [];
// 	};

// 	//  uses getPrimary/getContingent instead of hardcoded VEB fields
// 	const validateChangeInBeneficiary = useCallback((): {
// 		isEmployeeBeneficiaryValid: boolean;
// 		isSpouseBeneficiaryValid: boolean;
// 		isChildrenBeneficiaryValid: boolean;
// 	} => {
// 		let isEmployeeBeneficiaryValid = true;
// 		let isSpouseBeneficiaryValid = spouseEnrollment && spouseEnrollment.length > 0 ? true : false;
// 		let isChildrenBeneficiaryValid = childrenEnrollment && childrenEnrollment.length > 0 ? true : false;

// 		if (employeeEnrollment && employeeEnrollment.length > 0) {
// 			isEmployeeBeneficiaryValid = !areArraysEqual(
// 				employeePrimaryBeneficiary,
// 				getPrimary(employeeEnrollment[0]) // handleing both VEB and core
// 			);
// 			isEmployeeBeneficiaryValid =
// 				isEmployeeBeneficiaryValid ||
// 				!areArraysEqual(employeeContingentBeneficiary, getContingent(employeeEnrollment[0]));
// 		}
// 		if (spouseEnrollment && spouseEnrollment.length > 0) {
// 			isSpouseBeneficiaryValid = !areArraysEqual(spousePrimaryBeneficiary, getPrimary(spouseEnrollment[0]));
// 			isSpouseBeneficiaryValid =
// 				isSpouseBeneficiaryValid ||
// 				!areArraysEqual(spouseContingentBeneficiary, getContingent(spouseEnrollment[0]));
// 		}
// 		if (childrenEnrollment && childrenEnrollment.length > 0) {
// 			isChildrenBeneficiaryValid = !areArraysEqual(childrenPrimaryBeneficiary, getPrimary(childrenEnrollment[0]));
// 			isChildrenBeneficiaryValid =
// 				isChildrenBeneficiaryValid ||
// 				!areArraysEqual(childrenContingentBeneficiary, getContingent(childrenEnrollment[0]));
// 		}

// 		if (!isEmployeeBeneficiaryValid && !isSpouseBeneficiaryValid && !isChildrenBeneficiaryValid) {
// 			alert("you did not modify any data, no updates");
// 			handleOpenCloseEditBeneficiaryModal();
// 		}
// 		return { isEmployeeBeneficiaryValid, isSpouseBeneficiaryValid, isChildrenBeneficiaryValid };
// 	}, [
// 		childrenContingentBeneficiary,
// 		childrenEnrollment,
// 		childrenPrimaryBeneficiary,
// 		employeeContingentBeneficiary,
// 		employeeEnrollment,
// 		employeePrimaryBeneficiary,
// 		handleOpenCloseEditBeneficiaryModal,
// 		spouseContingentBeneficiary,
// 		spouseEnrollment,
// 		spousePrimaryBeneficiary
// 	]);

// 	const handleBeneficiaryValidate = useCallback(() => {
// 		const getTotalPercentage = (beneficiaries: any[]) => beneficiaries.reduce((sum, b) => sum + b.percentage, 0);

// 		const isFamilyProtection = plan_name === "Family Protection";

// 		// ─── Which documents have existing beneficiaries in DB ───────────────────
// 		const employeeHasBeneficiary = isFamilyProtection ? getPrimary(employeeEnrollment?.[0] ?? {}).length > 0 : true;

// 		const spouseHasBeneficiary = isFamilyProtection ? getPrimary(spouseEnrollment?.[0] ?? {}).length > 0 : true;

// 		const childHasBeneficiary = isFamilyProtection ? getPrimary(childrenEnrollment?.[0] ?? {}).length > 0 : true;

// 		// ─── Max primary per group ────────────────────────────────────────────────
// 		const employeeMaxPrimary = isFamilyProtection ? getPrimary(employeeEnrollment?.[0] ?? {}).length || 1 : 4;

// 		const spouseMaxPrimary = isFamilyProtection ? getPrimary(spouseEnrollment?.[0] ?? {}).length || 1 : 1;

// 		const childMaxPrimary = isFamilyProtection ? getPrimary(childrenEnrollment?.[0] ?? {}).length || 1 : 1;

// 		// ─── Employee section ─────────────────────────────────────────────────────
// 		if (
// 			coverage_for === "Employee Only" ||
// 			coverage_for === "Employee & Spouse" ||
// 			coverage_for === "Employee & Children" ||
// 			coverage_for === "Employee & Family"
// 		) {
// 			// ✅ Family Protection — skip if employee has no existing beneficiaries
// 			if (isFamilyProtection && !employeeHasBeneficiary) {
// 				alert("You cannot add beneficiary to Employee — no existing beneficiary found!");
// 				return false;
// 			}

// 			if (employeePrimaryBeneficiary.length === 0) {
// 				alert("Employee must have atleast One Primary Beneficiary!");
// 				return false;
// 			}
// 			if (employeePrimaryBeneficiary.length > employeeMaxPrimary) {
// 				alert(
// 					isFamilyProtection
// 						? `Employee can only have ${employeeMaxPrimary} Primary Beneficiar${
// 								employeeMaxPrimary === 1 ? "y" : "ies"
// 						  } for Family Protection!`
// 						: "Employee can have atmost Four Primary Beneficiaries!"
// 				);
// 				return false;
// 			}
// 			const employeePrimaryTotal = getTotalPercentage(employeePrimaryBeneficiary);
// 			if (employeePrimaryTotal !== 100 && employeePrimaryTotal !== 0) {
// 				alert("Primary Beneficiary Percentage must be all total 100%!");
// 				return false;
// 			}

// 			if (employeeContingentBeneficiary.length !== 0) {
// 				if (employeeContingentBeneficiary.length !== 1) {
// 					alert("Employee can have only One Contingent Beneficiary!");
// 					return false;
// 				}
// 				const employeeContingentTotal = getTotalPercentage(employeeContingentBeneficiary);
// 				if (employeeContingentTotal !== 100 && employeeContingentTotal !== 0) {
// 					alert("Contingent Beneficiary Percentage must be all total 100%!");
// 					return false;
// 				}
// 			}
// 		}

// 		// ─── Spouse section ───────────────────────────────────────────────────────
// 		if (
// 			coverage_for === "Spouse Only" ||
// 			coverage_for === "Employee & Spouse" ||
// 			coverage_for === "Spouse & Children" ||
// 			coverage_for === "Employee & Family"
// 		) {
// 			if (spouseEnrollment && spouseEnrollment.length > 0) {
// 				// ✅ Family Protection — skip if spouse has no existing beneficiaries
// 				if (isFamilyProtection && !spouseHasBeneficiary) {
// 					alert("You cannot add beneficiary to Spouse — no existing beneficiary found!");
// 					return false;
// 				}

// 				if (spousePrimaryBeneficiary.length === 0) {
// 					alert("Spouse must have atleast one Primary Beneficiary!");
// 					return false;
// 				}
// 				if (spousePrimaryBeneficiary.length > spouseMaxPrimary) {
// 					alert(
// 						isFamilyProtection
// 							? `Spouse can only have ${spouseMaxPrimary} Primary Beneficiar${
// 									spouseMaxPrimary === 1 ? "y" : "ies"
// 							  } for Family Protection!`
// 							: "Spouse can have only One Primary Beneficiary!"
// 					);
// 					return false;
// 				}
// 				const spousePrimaryTotal = getTotalPercentage(spousePrimaryBeneficiary);
// 				if (spousePrimaryTotal !== 100 && spousePrimaryTotal !== 0) {
// 					alert("Spouse Beneficiary Percentage must be all total 100%!");
// 					return false;
// 				}

// 				if (spouseContingentBeneficiary.length !== 0) {
// 					if (spouseContingentBeneficiary.length !== 1) {
// 						alert("Spouse can have only One Contingent Beneficiary!");
// 						return false;
// 					}
// 					const spouseContingentTotal = getTotalPercentage(spouseContingentBeneficiary);
// 					if (spouseContingentTotal !== 100 && spouseContingentTotal !== 0) {
// 						alert("Contingent Beneficiary Percentage must be all total 100%!");
// 						return false;
// 					}
// 				}
// 			}
// 		}

// 		// ─── Children section ─────────────────────────────────────────────────────
// 		if (
// 			coverage_for === "Employee & Children" ||
// 			coverage_for === "Spouse & Children" ||
// 			coverage_for === "Employee & Family"
// 		) {
// 			if (childrenEnrollment && childrenEnrollment.length > 0) {
// 				// ✅ Family Protection — skip if child has no existing beneficiaries
// 				if (isFamilyProtection && !childHasBeneficiary) {
// 					alert("You cannot add beneficiary to Child — no existing beneficiary found!");
// 					return false;
// 				}

// 				if (childrenPrimaryBeneficiary.length === 0) {
// 					alert("Child must have atleast One Primary Beneficiary!");
// 					return false;
// 				}
// 				if (childrenPrimaryBeneficiary.length > childMaxPrimary) {
// 					alert(
// 						isFamilyProtection
// 							? `Child can only have ${childMaxPrimary} Primary Beneficiar${
// 									childMaxPrimary === 1 ? "y" : "ies"
// 							  } for Family Protection!`
// 							: "Child can have only One Primary Beneficiary!"
// 					);
// 					return false;
// 				}
// 				const childPrimaryTotal = getTotalPercentage(childrenPrimaryBeneficiary);
// 				if (childPrimaryTotal !== 100 && childPrimaryTotal !== 0) {
// 					alert("Child Beneficiary Percentage must be all total 100%!");
// 					return false;
// 				}

// 				if (childrenContingentBeneficiary.length !== 0) {
// 					if (childrenContingentBeneficiary.length !== 1) {
// 						alert("Child can have only One Contingent Beneficiary!");
// 						return false;
// 					}
// 					const childContingentTotal = getTotalPercentage(childrenContingentBeneficiary);
// 					if (childContingentTotal !== 100 && childContingentTotal !== 0) {
// 						alert("Contingent Beneficiary Percentage must be all total 100%!");
// 						return false;
// 					}
// 				}
// 			}
// 		}

// 		return true;
// 	}, [
// 		coverage_for,
// 		plan_name,
// 		employeeEnrollment,
// 		spouseEnrollment,
// 		childrenEnrollment,
// 		employeePrimaryBeneficiary,
// 		employeeContingentBeneficiary,
// 		spousePrimaryBeneficiary,
// 		spouseContingentBeneficiary,
// 		childrenPrimaryBeneficiary,
// 		childrenContingentBeneficiary
// 	]);

// 	//  FIX 2: payload uses correct field names based on plan_type
// 	const handleEditBeneficiary = useCallback(async () => {
// 		const isValidBeneficiary = handleBeneficiaryValidate();
// 		const { isEmployeeBeneficiaryValid, isSpouseBeneficiaryValid, isChildrenBeneficiaryValid } =
// 			validateChangeInBeneficiary();

// 		if (
// 			isValidBeneficiary &&
// 			(isEmployeeBeneficiaryValid || isSpouseBeneficiaryValid || isChildrenBeneficiaryValid)
// 		) {
// 			const primaryField = isCorePlan ? "primary_beneficiery" : "VEB_primary_beneficiary";
// 			const contingentField = isCorePlan ? "contingent_beneficiery" : "VEB_contingent_beneficiary";

// 			const payload: any = {};
// 			payload["employee_SSN"] = employeeEnrollment[0].insured_SSN;
// 			payload["plan_type"] = plan_type;
// 			payload["group_number"] = employeeEnrollment[0].group_number;
// 			payload["plan_code"] = employeeEnrollment[0].plan_code;
// 			payload["base_plan_name"] = employeeEnrollment[0].base_plan_name;

// 			if (isEmployeeBeneficiaryValid) {
// 				payload["employee"] = {
// 					_id: employeeEnrollment[0]._id,
// 					[primaryField]: employeePrimaryBeneficiary,
// 					[contingentField]: employeeContingentBeneficiary
// 				};
// 			}
// 			if (isSpouseBeneficiaryValid && spouseEnrollment && spouseEnrollment.length > 0) {
// 				payload["spouse"] = {
// 					_id: spouseEnrollment[0]._id,
// 					[primaryField]: spousePrimaryBeneficiary,
// 					[contingentField]: spouseContingentBeneficiary
// 				};
// 			}
// 			if (isChildrenBeneficiaryValid && childrenEnrollment && childrenEnrollment.length > 0) {
// 				const childrenIds = childrenEnrollment.map((children: any) => children._id);
// 				payload["children"] = {
// 					_ids: childrenIds,
// 					[primaryField]: childrenPrimaryBeneficiary,
// 					[contingentField]: childrenContingentBeneficiary
// 				};
// 			}

// 			try {
// 				const editBeneficiary = await trackPromise(api.beneficiary.editBeneficiary(payload));
// 				if (editBeneficiary) {
// 					alert("beneficiary updated");
// 					window.location.reload();
// 				} else {
// 					alert("something went wrong");
// 				}
// 			} catch (err) {
// 				alert(err);
// 			}
// 			handleOpenCloseEditBeneficiaryModal();
// 		}
// 	}, [
// 		childrenContingentBeneficiary,
// 		childrenEnrollment,
// 		childrenPrimaryBeneficiary,
// 		employeeContingentBeneficiary,
// 		employeeEnrollment,
// 		employeePrimaryBeneficiary,
// 		handleBeneficiaryValidate,
// 		handleOpenCloseEditBeneficiaryModal,
// 		isCorePlan,
// 		plan_type,
// 		spouseContingentBeneficiary,
// 		spouseEnrollment,
// 		spousePrimaryBeneficiary,
// 		validateChangeInBeneficiary
// 	]);

// 	useEffect(() => {
// 		if (!enrollments?.length) return;

// 		// Split enrollments by relationship
// 		const empEnrollment = enrollments.filter(
// 			(enrollment: any) =>
// 				enrollment.insured_SSN === enrollment.member_SSN &&
// 				(enrollment["member"]?.relationship === null || enrollment["member"]?.relationship === undefined)
// 		);
// 		const spEnrollment = enrollments.filter((enrollment: any) => enrollment["member"]?.relationship === "SPOUSE");
// 		const chEnrollment = enrollments.filter(
// 			(enrollment: any) =>
// 				enrollment["member"]?.relationship === "CHILD" || enrollment["member"]?.relationship === "STEP CHILD"
// 		);

// 		if (empEnrollment.length > 0) setEmployeeEnrollment(empEnrollment);
// 		if (spEnrollment.length > 0) setSpouseEnrollment(spEnrollment);
// 		if (chEnrollment.length > 0) setChildrenEnrollment(chEnrollment);

// 		// ─── Helper — normalize beneficiary
// 		const normalizeBeneficiary = (b: any) => ({
// 			...b,
// 			first_name: b.first_name || (b.name ? b.name.split(" ")[0] : "") || "",
// 			last_name: b.last_name || (b.name ? b.name.split(" ").slice(1).join(" ") : "") || "",
// 			type: b.type || "Primary"
// 		});

// 		// ─── Helper — safely get beneficiaries
// 		const getSafePrimary = (enrollment: any): any[] =>
// 			enrollment ? getPrimary(enrollment).map(normalizeBeneficiary) : [];

// 		const getSafeContingent = (enrollment: any): any[] =>
// 			enrollment ? getContingent(enrollment).map(normalizeBeneficiary) : [];

// 		// ─── PRIMARY ─────────────────────────────────────────────────────────────
// 		// Each group reads from its OWN enrollment — no index-based assumption
// 		setEmployeePrimaryBeneficiary(getSafePrimary(empEnrollment[0]));
// 		setSpousePrimaryBeneficiary(getSafePrimary(spEnrollment[0]));
// 		setChildrenPrimaryBeneficiary(getSafePrimary(chEnrollment[0]));

// 		// ─── CONTINGENT ──────────────────────────────────────────────────────────
// 		setEmployeeContingentBeneficiary(getSafeContingent(empEnrollment[0]));
// 		setSpouseContingentBeneficiary(getSafeContingent(spEnrollment[0]));
// 		setChildrenContingentBeneficiary(getSafeContingent(chEnrollment[0]));
// 	}, [enrollments]); //  removed base_plan_name from deps since filter removed

// 	useEffect(() => {
// 		const spouseDetails = dependents.find((dependent: any) => dependent.relationship === "SPOUSE");
// 		if (spouseDetails) setSpouse(spouseDetails);
// 	}, [dependents]);

// 	const renderForm = () => {
// 		if (!enrollments || enrollments.length === 0) return <></>;

// 		const currentBasePlanName = enrollments[0].base_plan_name;
// 		const isFamilyProtection = plan_name === "Family Protection";

// 		// ─── Which sections to show based on existing DB beneficiaries ───────────
// 		const employeeHasBeneficiary = isFamilyProtection ? getPrimary(employeeEnrollment?.[0] ?? {}).length > 0 : true;

// 		const spouseHasBeneficiary = isFamilyProtection ? getPrimary(spouseEnrollment?.[0] ?? {}).length > 0 : true;

// 		const childHasBeneficiary = isFamilyProtection ? getPrimary(childrenEnrollment?.[0] ?? {}).length > 0 : true;

// 		const sharedProps = {
// 			employeePrimaryBeneficiary,
// 			setEmployeePrimaryBeneficiary,
// 			childrenPrimaryBeneficiary,
// 			setChildrenPrimaryBeneficiary,
// 			spousePrimaryBeneficiary,
// 			setSpousePrimaryBeneficiary,
// 			employeeContingentBeneficiary,
// 			setEmployeeContingentBeneficiary,
// 			childrenContingentBeneficiary,
// 			setChildrenContingentBeneficiary,
// 			spouseContingentBeneficiary,
// 			setSpouseContingentBeneficiary,
// 			dependents,
// 			member,
// 			spouse,
// 			isChild: false,
// 			coverage_for,
// 			// ─── ADD THESE ────────────────────────────────────────────────────────
// 			isFamilyProtection,
// 			employeeHasBeneficiary,
// 			spouseHasBeneficiary,
// 			childHasBeneficiary
// 		};

// 		if (currentBasePlanName === VEB_PLAN_NAMES.whole_life) {
// 			return <EditWholeLifeBeneficiary {...sharedProps} />;
// 		}

// 		if (
// 			currentBasePlanName === VEB_PLAN_NAMES.family_protection ||
// 			currentBasePlanName === "Term Life Coverage" ||
// 			currentBasePlanName === "Group Limited Indemnity"
// 		) {
// 			return <EditTermLifeToAge {...sharedProps} />;
// 		}

// 		if (isCorePlan) {
// 			return <EditTermLifeToAge {...sharedProps} />;
// 		}

// 		return <></>;
// 	};

// 	return (
// 		<div
// 			style={{
// 				padding: "1.5rem",
// 				background: "var(--color-background-primary)",
// 				borderRadius: "var(--border-radius-lg)",
// 				border: "0.5px solid var(--color-border-tertiary)"
// 			}}
// 		>
// 			{renderForm()}

// 			<div
// 				style={{
// 					borderTop: "0.5px solid var(--color-border-tertiary)",
// 					paddingTop: "1.25rem",
// 					marginTop: "1.5rem",
// 					display: "flex",
// 					justifyContent: "flex-end"
// 				}}
// 			>
// 				<Button
// 					variant="contained"
// 					onClick={handleEditBeneficiary}
// 					style={{
// 						backgroundColor: theme.button.background_color,
// 						color: theme.button.color,
// 						borderRadius: "var(--border-radius-md)",
// 						padding: "8px 20px",
// 						fontSize: "14px",
// 						fontWeight: 500,
// 						textTransform: "none"
// 					}}
// 				>
// 					Update Beneficiary
// 				</Button>
// 			</div>
// 		</div>
// 	);
// };
// export default EditBeneficiaryForm;

/* eslint-disable */

import { Button, Grid } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { AuthContext, DependentsContext, ThemeContext } from "../../../../../contexts";
import { VEB_PLAN_NAMES } from "../../../../../constants/plan";
import EditWholeLifeBeneficiary from "../../../../pages/VEBEnrollment/editBeneficiary/editWholeLifeBeneficiary/EditWholeLifeBeneficiary";
import EditTermLifeToAge from "../../../../pages/VEBEnrollment/editBeneficiary/editTermLifeToAge/EditTermLifeToAge";
import { BV2Beneficiery } from "../../../../../types/BV2Beneficiery.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";

type editBeneficiaryFormPropsType = {
	plan_type: string;
	plan_code: string;
	plan_name: string;
	base_plan_name: string | undefined;
	enrollments: any;
	handleOpenCloseEditBeneficiaryModal: () => void;
};

// ─── Plan name constants ──────────────────────────────────────────────────────
const GROUP_LIMITED_INDEMNITY_VARIANTS = ["Group Limited Indemnity", "Group Limited Indemnity New"];

const EditBeneficiaryForm: React.FC<editBeneficiaryFormPropsType> = ({
	plan_type,
	plan_code,
	plan_name,
	base_plan_name,
	enrollments,
	handleOpenCloseEditBeneficiaryModal
}) => {
	const { member } = useContext(AuthContext);
	const { dependents } = useContext(DependentsContext);
	const { theme } = useContext(ThemeContext);

	const [spouse, setSpouse] = useState<any>();

	// primary beneficiary
	const [employeePrimaryBeneficiary, setEmployeePrimaryBeneficiary] = useState<any[]>([]);
	const [childrenPrimaryBeneficiary, setChildrenPrimaryBeneficiary] = useState<any[]>([]);
	const [spousePrimaryBeneficiary, setSpousePrimaryBeneficiary] = useState<any[]>([]);

	// contingent beneficiary
	const [employeeContingentBeneficiary, setEmployeeContingentBeneficiary] = useState<any[]>([]);
	const [childrenContingentBeneficiary, setChildrenContingentBeneficiary] = useState<any[]>([]);
	const [spouseContingentBeneficiary, setSpouseContingentBeneficiary] = useState<any[]>([]);

	// individual enrollments
	const [employeeEnrollment, setEmployeeEnrollment] = useState<any>(null);
	const [spouseEnrollment, setSpouseEnrollment] = useState<any>(null);
	const [childrenEnrollment, setChildrenEnrollment] = useState<any>(null);

	// ─── Derive coverage_for from actual enrollment records ───────────────────
	// NOTE: The enrollment data uses coverage_code "EF" (Employee & Family), but
	// we derive coverage_for from actual relationship records present in enrollments
	// so that UI sections only render for members that truly have enrollment rows.
	const coverage_for = (() => {
		const hasSpouse = enrollments.some((e: any) => e["member"]?.relationship === "SPOUSE");
		const hasChildren = enrollments.some(
			(e: any) => e["member"]?.relationship === "CHILD" || e["member"]?.relationship === "STEP CHILD"
		);
		if (hasSpouse && hasChildren) return "Employee & Family";
		if (hasSpouse) return "Employee & Spouse";
		if (hasChildren) return "Employee & Children";
		return "Employee Only";
	})();

	// ─── Single source of truth for plan type ────────────────────────────────
	// plan_type comes from props; "core" means legacy field names are used.
	// The sample enrollment uses VEB fields, so isCorePlan will be false
	// unless the caller explicitly passes plan_type="core".
	const isCorePlan = plan_type === "core";

	// ─── Field-name helpers ───────────────────────────────────────────────────
	// Supports both VEB field names ("VEB_primary_beneficiary") and legacy core
	// field names ("primary_beneficiery") transparently.
	const getPrimary = (enrollment: any): any[] => {
		if (enrollment["VEB_primary_beneficiary"]?.length > 0) return enrollment["VEB_primary_beneficiary"];
		if (enrollment["primary_beneficiery"]?.length > 0) return enrollment["primary_beneficiery"];
		return [];
	};

	const getContingent = (enrollment: any): any[] => {
		if (enrollment["VEB_contingent_beneficiary"]?.length > 0) return enrollment["VEB_contingent_beneficiary"];
		if (enrollment["contingent_beneficiery"]?.length > 0) return enrollment["contingent_beneficiery"];
		return [];
	};

	const validateBeneficiary = useCallback((beneficiary: BV2Beneficiery[], type: "PRIMARY" | "CONTINGENT") => {
		let sum = 0;
		for (let i = 0; i < beneficiary.length; i++) {
			sum += beneficiary[i].percentage;
		}
		return sum;
	}, []);

	const areArraysEqual = (arr1: any[], arr2: any[]) => {
		const a1 = arr1 ?? [];
		const a2 = arr2 ?? [];
		if (a1.length !== a2.length) return false;
		const normalize = (obj: any) => JSON.stringify(obj, Object.keys(obj).sort());
		const set1 = new Set(a1.map(normalize));
		const set2 = new Set(a2.map(normalize));
		return [...set1].every((item: any) => set2.has(item));
	};

	const validateChangeInBeneficiary = useCallback((): {
		isEmployeeBeneficiaryValid: boolean;
		isSpouseBeneficiaryValid: boolean;
		isChildrenBeneficiaryValid: boolean;
	} => {
		let isEmployeeBeneficiaryValid = true;
		let isSpouseBeneficiaryValid = spouseEnrollment && spouseEnrollment.length > 0 ? true : false;
		let isChildrenBeneficiaryValid = childrenEnrollment && childrenEnrollment.length > 0 ? true : false;

		if (employeeEnrollment && employeeEnrollment.length > 0) {
			isEmployeeBeneficiaryValid = !areArraysEqual(employeePrimaryBeneficiary, getPrimary(employeeEnrollment[0]));
			isEmployeeBeneficiaryValid =
				isEmployeeBeneficiaryValid ||
				!areArraysEqual(employeeContingentBeneficiary, getContingent(employeeEnrollment[0]));
		}
		if (spouseEnrollment && spouseEnrollment.length > 0) {
			isSpouseBeneficiaryValid = !areArraysEqual(spousePrimaryBeneficiary, getPrimary(spouseEnrollment[0]));
			isSpouseBeneficiaryValid =
				isSpouseBeneficiaryValid ||
				!areArraysEqual(spouseContingentBeneficiary, getContingent(spouseEnrollment[0]));
		}
		if (childrenEnrollment && childrenEnrollment.length > 0) {
			isChildrenBeneficiaryValid = !areArraysEqual(childrenPrimaryBeneficiary, getPrimary(childrenEnrollment[0]));
			isChildrenBeneficiaryValid =
				isChildrenBeneficiaryValid ||
				!areArraysEqual(childrenContingentBeneficiary, getContingent(childrenEnrollment[0]));
		}

		if (!isEmployeeBeneficiaryValid && !isSpouseBeneficiaryValid && !isChildrenBeneficiaryValid) {
			alert("you did not modify any data, no updates");
			handleOpenCloseEditBeneficiaryModal();
		}
		return {
			isEmployeeBeneficiaryValid,
			isSpouseBeneficiaryValid,
			isChildrenBeneficiaryValid
		};
	}, [
		childrenContingentBeneficiary,
		childrenEnrollment,
		childrenPrimaryBeneficiary,
		employeeContingentBeneficiary,
		employeeEnrollment,
		employeePrimaryBeneficiary,
		handleOpenCloseEditBeneficiaryModal,
		spouseContingentBeneficiary,
		spouseEnrollment,
		spousePrimaryBeneficiary
	]);

	const handleBeneficiaryValidate = useCallback(() => {
		const getTotalPercentage = (beneficiaries: any[]) => beneficiaries.reduce((sum, b) => sum + b.percentage, 0);

		const isFamilyProtection = plan_name === "Family Protection";

		const employeeHasBeneficiary = isFamilyProtection ? getPrimary(employeeEnrollment?.[0] ?? {}).length > 0 : true;
		const spouseHasBeneficiary = isFamilyProtection ? getPrimary(spouseEnrollment?.[0] ?? {}).length > 0 : true;
		const childHasBeneficiary = isFamilyProtection ? getPrimary(childrenEnrollment?.[0] ?? {}).length > 0 : true;

		const employeeMaxPrimary = isFamilyProtection ? getPrimary(employeeEnrollment?.[0] ?? {}).length || 1 : 4;
		const spouseMaxPrimary = isFamilyProtection ? getPrimary(spouseEnrollment?.[0] ?? {}).length || 1 : 1;
		const childMaxPrimary = isFamilyProtection ? getPrimary(childrenEnrollment?.[0] ?? {}).length || 1 : 1;

		// ─── Employee section ─────────────────────────────────────────────────
		if (
			coverage_for === "Employee Only" ||
			coverage_for === "Employee & Spouse" ||
			coverage_for === "Employee & Children" ||
			coverage_for === "Employee & Family"
		) {
			if (isFamilyProtection && !employeeHasBeneficiary) {
				alert("You cannot add beneficiary to Employee — no existing beneficiary found!");
				return false;
			}
			if (employeePrimaryBeneficiary.length === 0) {
				alert("Employee must have atleast One Primary Beneficiary!");
				return false;
			}
			if (employeePrimaryBeneficiary.length > employeeMaxPrimary) {
				alert(
					isFamilyProtection
						? `Employee can only have ${employeeMaxPrimary} Primary Beneficiar${
								employeeMaxPrimary === 1 ? "y" : "ies"
						  } for Family Protection!`
						: "Employee can have atmost Four Primary Beneficiaries!"
				);
				return false;
			}
			const employeePrimaryTotal = getTotalPercentage(employeePrimaryBeneficiary);
			if (employeePrimaryTotal !== 100 && employeePrimaryTotal !== 0) {
				alert("Primary Beneficiary Percentage must be all total 100%!");
				return false;
			}
			if (employeeContingentBeneficiary.length !== 0) {
				if (employeeContingentBeneficiary.length !== 1) {
					alert("Employee can have only One Contingent Beneficiary!");
					return false;
				}
				const employeeContingentTotal = getTotalPercentage(employeeContingentBeneficiary);
				if (employeeContingentTotal !== 100 && employeeContingentTotal !== 0) {
					alert("Contingent Beneficiary Percentage must be all total 100%!");
					return false;
				}
			}
		}

		// ─── Spouse section ───────────────────────────────────────────────────
		if (
			coverage_for === "Spouse Only" ||
			coverage_for === "Employee & Spouse" ||
			coverage_for === "Spouse & Children" ||
			coverage_for === "Employee & Family"
		) {
			if (spouseEnrollment && spouseEnrollment.length > 0) {
				if (isFamilyProtection && !spouseHasBeneficiary) {
					alert("You cannot add beneficiary to Spouse — no existing beneficiary found!");
					return false;
				}
				if (spousePrimaryBeneficiary.length === 0) {
					alert("Spouse must have atleast one Primary Beneficiary!");
					return false;
				}
				if (spousePrimaryBeneficiary.length > spouseMaxPrimary) {
					alert(
						isFamilyProtection
							? `Spouse can only have ${spouseMaxPrimary} Primary Beneficiar${
									spouseMaxPrimary === 1 ? "y" : "ies"
							  } for Family Protection!`
							: "Spouse can have only One Primary Beneficiary!"
					);
					return false;
				}
				const spousePrimaryTotal = getTotalPercentage(spousePrimaryBeneficiary);
				if (spousePrimaryTotal !== 100 && spousePrimaryTotal !== 0) {
					alert("Spouse Beneficiary Percentage must be all total 100%!");
					return false;
				}
				if (spouseContingentBeneficiary.length !== 0) {
					if (spouseContingentBeneficiary.length !== 1) {
						alert("Spouse can have only One Contingent Beneficiary!");
						return false;
					}
					const spouseContingentTotal = getTotalPercentage(spouseContingentBeneficiary);
					if (spouseContingentTotal !== 100 && spouseContingentTotal !== 0) {
						alert("Contingent Beneficiary Percentage must be all total 100%!");
						return false;
					}
				}
			}
		}

		// ─── Children section ─────────────────────────────────────────────────
		if (
			coverage_for === "Employee & Children" ||
			coverage_for === "Spouse & Children" ||
			coverage_for === "Employee & Family"
		) {
			if (childrenEnrollment && childrenEnrollment.length > 0) {
				if (isFamilyProtection && !childHasBeneficiary) {
					alert("You cannot add beneficiary to Child — no existing beneficiary found!");
					return false;
				}
				if (childrenPrimaryBeneficiary.length === 0) {
					alert("Child must have atleast One Primary Beneficiary!");
					return false;
				}
				if (childrenPrimaryBeneficiary.length > childMaxPrimary) {
					alert(
						isFamilyProtection
							? `Child can only have ${childMaxPrimary} Primary Beneficiar${
									childMaxPrimary === 1 ? "y" : "ies"
							  } for Family Protection!`
							: "Child can have only One Primary Beneficiary!"
					);
					return false;
				}
				const childPrimaryTotal = getTotalPercentage(childrenPrimaryBeneficiary);
				if (childPrimaryTotal !== 100 && childPrimaryTotal !== 0) {
					alert("Child Beneficiary Percentage must be all total 100%!");
					return false;
				}
				if (childrenContingentBeneficiary.length !== 0) {
					if (childrenContingentBeneficiary.length !== 1) {
						alert("Child can have only One Contingent Beneficiary!");
						return false;
					}
					const childContingentTotal = getTotalPercentage(childrenContingentBeneficiary);
					if (childContingentTotal !== 100 && childContingentTotal !== 0) {
						alert("Contingent Beneficiary Percentage must be all total 100%!");
						return false;
					}
				}
			}
		}

		return true;
	}, [
		coverage_for,
		plan_name,
		employeeEnrollment,
		spouseEnrollment,
		childrenEnrollment,
		employeePrimaryBeneficiary,
		employeeContingentBeneficiary,
		spousePrimaryBeneficiary,
		spouseContingentBeneficiary,
		childrenPrimaryBeneficiary,
		childrenContingentBeneficiary
	]);

	const handleEditBeneficiary = useCallback(async () => {
		const isValidBeneficiary = handleBeneficiaryValidate();
		const { isEmployeeBeneficiaryValid, isSpouseBeneficiaryValid, isChildrenBeneficiaryValid } =
			validateChangeInBeneficiary();

		if (
			isValidBeneficiary &&
			(isEmployeeBeneficiaryValid || isSpouseBeneficiaryValid || isChildrenBeneficiaryValid)
		) {
			// ─── Use correct field names based on plan_type ───────────────────
			// The sample enrollment uses VEB fields; isCorePlan=false → VEB field names.
			const primaryField = isCorePlan ? "primary_beneficiery" : "VEB_primary_beneficiary";
			const contingentField = isCorePlan ? "contingent_beneficiery" : "VEB_contingent_beneficiary";

			const payload: any = {};
			payload["employee_SSN"] = employeeEnrollment[0].insured_SSN; // "098098098"
			payload["plan_type"] = plan_type;
			payload["group_number"] = employeeEnrollment[0].group_number; // 220
			payload["plan_code"] = employeeEnrollment[0].plan_code; // "GLI-ALL-NEW-2026"
			payload["base_plan_name"] = employeeEnrollment[0].base_plan_name; // "Group Limited Indemnity New"

			if (isEmployeeBeneficiaryValid) {
				payload["employee"] = {
					_id: employeeEnrollment[0]._id,
					[primaryField]: employeePrimaryBeneficiary,
					[contingentField]: employeeContingentBeneficiary
				};
			}
			if (isSpouseBeneficiaryValid && spouseEnrollment && spouseEnrollment.length > 0) {
				payload["spouse"] = {
					_id: spouseEnrollment[0]._id,
					[primaryField]: spousePrimaryBeneficiary,
					[contingentField]: spouseContingentBeneficiary
				};
			}
			if (isChildrenBeneficiaryValid && childrenEnrollment && childrenEnrollment.length > 0) {
				const childrenIds = childrenEnrollment.map((children: any) => children._id);
				payload["children"] = {
					_ids: childrenIds,
					[primaryField]: childrenPrimaryBeneficiary,
					[contingentField]: childrenContingentBeneficiary
				};
			}

			try {
				const editBeneficiary = await trackPromise(api.beneficiary.editBeneficiary(payload));
				if (editBeneficiary) {
					alert("beneficiary updated");
					window.location.reload();
				} else {
					alert("something went wrong");
				}
			} catch (err) {
				alert(err);
			}
			handleOpenCloseEditBeneficiaryModal();
		}
	}, [
		childrenContingentBeneficiary,
		childrenEnrollment,
		childrenPrimaryBeneficiary,
		employeeContingentBeneficiary,
		employeeEnrollment,
		employeePrimaryBeneficiary,
		handleBeneficiaryValidate,
		handleOpenCloseEditBeneficiaryModal,
		isCorePlan,
		plan_type,
		spouseContingentBeneficiary,
		spouseEnrollment,
		spousePrimaryBeneficiary,
		validateChangeInBeneficiary
	]);

	useEffect(() => {
		if (!enrollments?.length) return;

		// ─── Split enrollments by relationship ───────────────────────────────
		// Employee: insured_SSN === member_SSN AND relationship is null/undefined
		// (matches the sample record where member.relationship = null)
		const empEnrollment = enrollments.filter(
			(enrollment: any) =>
				enrollment.insured_SSN === enrollment.member_SSN &&
				(enrollment["member"]?.relationship === null || enrollment["member"]?.relationship === undefined)
		);
		const spEnrollment = enrollments.filter((enrollment: any) => enrollment["member"]?.relationship === "SPOUSE");
		const chEnrollment = enrollments.filter(
			(enrollment: any) =>
				enrollment["member"]?.relationship === "CHILD" || enrollment["member"]?.relationship === "STEP CHILD"
		);

		if (empEnrollment.length > 0) setEmployeeEnrollment(empEnrollment);
		if (spEnrollment.length > 0) setSpouseEnrollment(spEnrollment);
		if (chEnrollment.length > 0) setChildrenEnrollment(chEnrollment);

		// ─── Normalize a beneficiary object ──────────────────────────────────
		// The sample stores "first_name"/"last_name" directly — this handles
		// both that format and older records that use a single "name" field.
		const normalizeBeneficiary = (b: any) => ({
			...b,
			first_name: b.first_name || (b.name ? b.name.split(" ")[0] : "") || "",
			last_name: b.last_name || (b.name ? b.name.split(" ").slice(1).join(" ") : "") || "",
			type: b.type || "Primary"
		});

		const getSafePrimary = (enrollment: any): any[] =>
			enrollment ? getPrimary(enrollment).map(normalizeBeneficiary) : [];

		const getSafeContingent = (enrollment: any): any[] =>
			enrollment ? getContingent(enrollment).map(normalizeBeneficiary) : [];

		// ─── Seed state from the DB enrollment records ───────────────────────
		setEmployeePrimaryBeneficiary(getSafePrimary(empEnrollment[0]));
		setSpousePrimaryBeneficiary(getSafePrimary(spEnrollment[0]));
		setChildrenPrimaryBeneficiary(getSafePrimary(chEnrollment[0]));

		setEmployeeContingentBeneficiary(getSafeContingent(empEnrollment[0]));
		setSpouseContingentBeneficiary(getSafeContingent(spEnrollment[0]));
		setChildrenContingentBeneficiary(getSafeContingent(chEnrollment[0]));
	}, [enrollments]);

	useEffect(() => {
		const spouseDetails = dependents.find((dependent: any) => dependent.relationship === "SPOUSE");
		if (spouseDetails) setSpouse(spouseDetails);
	}, [dependents]);

	const renderForm = () => {
		if (!enrollments || enrollments.length === 0) return <></>;

		const currentBasePlanName = enrollments[0].base_plan_name ?? base_plan_name ?? "";

		const isFamilyProtection = plan_name === "Family Protection";

		const employeeHasBeneficiary = getPrimary(employeeEnrollment?.[0] ?? {}).length > 0;
		const spouseHasBeneficiary = getPrimary(spouseEnrollment?.[0] ?? {}).length > 0;
		const childHasBeneficiary = getPrimary(childrenEnrollment?.[0] ?? {}).length > 0;

		// ─── Check if ANY enrollment record has primary beneficiaries ────────────
		// This makes the form dynamic — it renders for any plan that has
		// existing beneficiary data, regardless of plan name.
		const hasBeneficiaryData = enrollments.some((e: any) => getPrimary(e).length > 0);

		if (!hasBeneficiaryData) return <></>;

		const sharedProps = {
			employeePrimaryBeneficiary,
			setEmployeePrimaryBeneficiary,
			childrenPrimaryBeneficiary,
			setChildrenPrimaryBeneficiary,
			spousePrimaryBeneficiary,
			setSpousePrimaryBeneficiary,
			employeeContingentBeneficiary,
			setEmployeeContingentBeneficiary,
			childrenContingentBeneficiary,
			setChildrenContingentBeneficiary,
			spouseContingentBeneficiary,
			setSpouseContingentBeneficiary,
			dependents,
			member,
			spouse,
			isChild: false,
			coverage_for,
			isFamilyProtection,
			employeeHasBeneficiary,
			spouseHasBeneficiary,
			childHasBeneficiary
		};

		// ─── Whole Life gets its own dedicated form ───────────────────────────────
		if (currentBasePlanName === VEB_PLAN_NAMES.whole_life) {
			return <EditWholeLifeBeneficiary {...sharedProps} />;
		}

		// ─── All other plans with beneficiary data use EditTermLifeToAge ──────────
		return <EditTermLifeToAge {...sharedProps} />;
	};

	return (
		<div
			style={{
				padding: "1.5rem",
				background: "var(--color-background-primary)",
				borderRadius: "var(--border-radius-lg)",
				border: "0.5px solid var(--color-border-tertiary)"
			}}
		>
			{renderForm()}

			<div
				style={{
					borderTop: "0.5px solid var(--color-border-tertiary)",
					paddingTop: "1.25rem",
					marginTop: "1.5rem",
					display: "flex",
					justifyContent: "flex-end"
				}}
			>
				<Button
					variant="contained"
					onClick={handleEditBeneficiary}
					style={{
						backgroundColor: theme.button.background_color,
						color: theme.button.color,
						borderRadius: "var(--border-radius-md)",
						padding: "8px 20px",
						fontSize: "14px",
						fontWeight: 500,
						textTransform: "none"
					}}
				>
					Update Beneficiary
				</Button>
			</div>
		</div>
	);
};

export default EditBeneficiaryForm;
